class FJFacets extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('input', this.onFormChange.bind(this));
    this.form.addEventListener('submit', (e) => e.preventDefault());

    this.heroAnchor = null;
    this.currentRequestController = null;

    const wrapper = document.getElementById('fj-collection-hero-wrapper');
    if (wrapper) {
      const initialValues = (wrapper.dataset.activeValues || '').split(' ').filter(Boolean);
      if (initialValues.length === 1) {
        this.heroAnchor = initialValues[0];
      }
    }

    this.onPopState = this.onPopState.bind(this);
  }

  connectedCallback() {
    window.addEventListener('popstate', this.onPopState);
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this.onPopState);
  }

  onPopState() {
    this.renderPage(window.location.search.slice(1), false);
  }

  onFormChange(event) {
    if (this.isMobileViewport()) return;
    this.applyFilters();
  }

  isMobileViewport() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  applyFilters() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams);
  }

  async renderPage(searchParams, updateHistory = true) {
    const url = `${window.location.pathname}?${searchParams}`;
    if (updateHistory) this.updateURL(url);

    if (this.currentRequestController) {
      this.currentRequestController.abort();
    }
    this.currentRequestController = new AbortController();
    const { signal } = this.currentRequestController;

    try {
      const response = await fetch(url, { signal });
      const htmlText = await response.text();
      const html = new DOMParser().parseFromString(htmlText, 'text/html');

      // Plain, unconditional updates — these always reflect current state
      this.updateSection('fj-product-grid', html);
      this.updateSection('fj-results-count', html);
      this.updateSection('fj-facets-container', html);
      this.updateSection('fj-collection-pagination', html);
      this.updateSection('fj-facets-sort-container', html);
      this.updateSection('fj-collection-breadcrumb-wrapper', html);

      // Hero keeps its own "sticky until deselected" behavior — separate logic
      this.updateHero(html);
    } catch (e) {
      if (e.name === 'AbortError') return;
      console.error('Failed to fetch filtered results:', e);
    }
  }

  updateHero(html) {
    const newWrapper = html.getElementById('fj-collection-hero-wrapper');
    const oldWrapper = document.getElementById('fj-collection-hero-wrapper');
    if (!newWrapper || !oldWrapper) return;

    const newValues = (newWrapper.dataset.activeValues || '').split(' ').filter(Boolean);

    // Anchor still checked, regardless of what else changed — leave hero untouched
    if (this.heroAnchor && newValues.includes(this.heroAnchor)) {
      return;
    }

    // Anchor is gone (or never existed) — re-evaluate
    if (newValues.length === 1) {
      this.heroAnchor = newValues[0];
      oldWrapper.innerHTML = newWrapper.innerHTML;
      oldWrapper.dataset.activeValues = newWrapper.dataset.activeValues;
    } else if (newValues.length === 0) {
      // No filters: use the server render (collection hero_brand fallback or empty)
      this.heroAnchor = null;
      oldWrapper.innerHTML = newWrapper.innerHTML;
      oldWrapper.dataset.activeValues = '';
    } else {
      this.heroAnchor = null;
      oldWrapper.innerHTML = '';
      oldWrapper.dataset.activeValues = '';
    }
  }

  updateSection(id, html) {
    const newElement = html.getElementById(id);
    const oldElement = document.getElementById(id);
    if (newElement && oldElement) {
      oldElement.innerHTML = newElement.innerHTML;
    }
  }

  updateURL(url) {
    history.pushState({ url }, '', url);
  }
}

customElements.define('fj-facets', FJFacets);